import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Field} from 'redux-form'
import {FormField} from '@cred/react-form-field'
import Label from '@cred/react-label'
import Font from '@cred/react-font'
import defaultStyles from './themes/default/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'
import thebalance1 from './themes/thebalance1/styles.module.scss'
import investopedia1 from './themes/investopedia1/styles.module.scss'
import forbes1 from './themes/forbes1/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import homes1 from './themes/homes1/styles.module.scss'
import insider from './themes/insider/styles.module.scss'
import withStyles from '@cred/react-theme'
import {emitOnChange} from '@cred/react-analytics/hoc'

const select = ({input, isDisabled = false, label, meta, children, placeholder, theme, styles, icon = true}) => {
    const withValueCls = input.value ? styles.withValue : ''

    return (
      <FormField className={withValueCls} status={meta} error={meta.error} placeholder={placeholder} value={input.value} label={label} icon={icon} theme={theme}>
        <select id={input.id || input.name} disabled={isDisabled} {...input}>
          {children}
        </select>
        <Label htmlFor={input.id || input.name}>
          {label}
        </Label>
      </FormField>
    )
  },
  selectWithAnalytics = /*#__PURE__*/ emitOnChange(select)

class Dropdown extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    inline: PropTypes.bool
  }

  static defaultProps = {
    component: selectWithAnalytics,
    inline: false
  }

  static displayName = 'Dropdown'

  render() {
    const {options, className, placeholder, theme, inline, icon, ...props} = this.props,
      styles = this.props.styles,
      inlineClass = inline ? styles.inline : ''

    return (
      <Font element="div" className={[styles.select, className, inlineClass].join(' ')} weight={inline ? 'semiBold' : 'regular'}>
        <Field type="text" options={options} placeholder={placeholder} icon={inline ? false : icon} {...props}>
          <optgroup label="">
            {placeholder &&
              <option value="" disabled>
                {placeholder}
              </option>
            }
            {options.map((option, index) =>
              <option key={index} value={option.value}>
                {option.label}
              </option>
            )}
          </optgroup>
        </Field>
      </Font>
    )
  }
}

export {Dropdown as DropdownNoHoc}

export default /*#__PURE__*/ withStyles(
  defaultStyles, {
    credible3,
    thebalance1,
    investopedia1,
    forbes1,
    fox1,
    homes1,
    insider
  }
)(Dropdown)
